import styled from 'styled-components';

import UiButton from '../../../../ui/button/UiButton';

export default styled(UiButton)`
    margin-bottom: ${({ theme }) => theme.layout.gutter};
` as React.ComponentType<Parameters<typeof UiButton>[0]>;
